module.exports = __webpack_public_path__ + "img/reservation.f170ca10.svg";